/*! wslibrary-options.js — 酒井格ライブラリー / レンタル楽譜の購入時オプション
 *  (2026-08-24 Winds Score / アプリ Infinite Options の置き換え)
 *
 *  必須項目(data-wsopt-required)が埋まるまで「カートに追加」を disabled にする。
 *  項目の中身は snippets/ws-library-options.liquid が出力する。
 *
 *  ボタンの disabled は他の自作スクリプトとも取り合いになる:
 *    data-wszep-disabled … 絶版             (wszeppan.js)
 *    data-wspre-locked   … 取り寄せ同梱      (ws-preorder-block-v2.js)
 *    data-wscopy-locked  … コピー禁止チェック (wscopy-notice.js)
 *    data-wsopt-locked   … ここ
 *  自分の印があるときだけ外し、他の印が残っていれば外さない。
 *  元から disabled のボタン(売り切れ・絶版)には触らない。
 */
(function () {
  'use strict';

  // アプリ側と同じ文言(snippets/ci-product-detail.liquid の errorMessages と揃える)
  var MSG_CHECK = 'チェックボックスをご確認下さい。';
  var MSG_TEXT  = 'テキストボックスをご入力下さい。';
  var OTHER_LOCKS = ['data-wspre-locked', 'data-wszep-disabled', 'data-wscopy-locked'];

  function formOf(box) {
    return box.closest ? box.closest('form[action*="/cart/add"]') : null;
  }

  function btnOf(box) {
    var form = formOf(box);
    return form ? form.querySelector('[name="add"], .add-to-cart, button[type="submit"]') : null;
  }

  function filled(el) {
    if (el.type === 'checkbox') return !!el.checked;
    return String(el.value || '').trim() !== '';
  }

  /** 未入力の必須項目 */
  function missing(box) {
    var out = [];
    var els = box.querySelectorAll('[data-wsopt-required]');
    for (var i = 0; i < els.length; i++) {
      if (!filled(els[i])) out.push(els[i]);
    }
    return out;
  }

  function lockedByOthers(el) {
    for (var i = 0; i < OTHER_LOCKS.length; i++) {
      if (el.hasAttribute(OTHER_LOCKS[i])) return true;
    }
    return false;
  }

  function lock(el, want) {
    if (el.getAttribute('data-wsopt-init') === null) {
      el.setAttribute('data-wsopt-init', el.disabled ? '1' : '0');
    }
    if (el.getAttribute('data-wsopt-init') === '1') return;   // 元から買えないボタンには触らない

    if (want) {
      el.setAttribute('data-wsopt-locked', '');
      if (el.disabled !== true) el.disabled = true;            // 同値なら触らない(監視の再帰防止)
      el.setAttribute('aria-disabled', 'true');
      // disabled のボタンはクリックイベントを出さないので、理由を出せるよう下に通す
      if (el.style.pointerEvents !== 'none') el.style.pointerEvents = 'none';
    } else if (el.hasAttribute('data-wsopt-locked')) {
      el.removeAttribute('data-wsopt-locked');
      if (lockedByOthers(el)) return;
      if (el.disabled !== false) el.disabled = false;
      el.setAttribute('aria-disabled', 'false');
      if (el.style.pointerEvents === 'none') el.style.pointerEvents = '';
    }
  }

  /** アプリ側が同じ商品にオプションを出しているあいだは自作を引っ込める
   *  (Infinite Options のオプションを削除した時点で自作が表に出る) */
  function appDuplicate() {
    var app = document.getElementById('infiniteoptions-container');
    return !!(app && app.querySelector('input, textarea, select'));
  }

  function rowOf(el) {
    return el.closest ? el.closest('.wsopt__row') : null;
  }

  function clearMsgs(box) {
    var rows = box.querySelectorAll('.wsopt__row');
    for (var i = 0; i < rows.length; i++) {
      rows[i].classList.remove('is-error');
      var m = rows[i].querySelector('[data-wsopt-msg]');
      if (m && !m.hidden) m.hidden = true;
    }
  }

  /** 未入力の項目に理由を出す */
  function showMsgs(box) {
    clearMsgs(box);
    var miss = missing(box);
    for (var i = 0; i < miss.length; i++) {
      var row = rowOf(miss[i]);
      if (!row) continue;
      row.classList.add('is-error');
      var m = row.querySelector('[data-wsopt-msg]');
      if (m) {
        var text = miss[i].type === 'checkbox' ? MSG_CHECK : MSG_TEXT;
        if (m.textContent !== text) m.textContent = text;
        m.hidden = false;
      }
    }
    if (miss.length) {
      var first = miss[0];
      if (first.focus) { try { first.focus({ preventScroll: false }); } catch (e) { first.focus(); } }
    }
  }

  function sync(box) {
    var btn = btnOf(box);

    if (appDuplicate()) {                    // アプリが出している → 自作は出さない・止めない
      if (!box.hidden) box.hidden = true;
      if (btn) lock(btn, false);
      return;
    }
    if (box.hidden) box.hidden = false;

    var miss = missing(box);
    if (!miss.length) clearMsgs(box);        // 埋まったらメッセージを消す
    if (btn) lock(btn, miss.length > 0);
  }

  function syncAll() {
    var boxes = document.querySelectorAll('[data-wsopt]');
    for (var i = 0; i < boxes.length; i++) sync(boxes[i]);
  }

  function init() {
    syncAll();

    // 入力・チェックの変化
    ['change', 'input'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        var t = e.target;
        if (t && t.closest && t.closest('[data-wsopt]')) syncAll();
      }, true);
    });

    // 止めている理由を出す。pointer-events:none で通ってきたクリックを**ボタンの位置**で拾う
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var form = t.closest('form[action*="/cart/add"]');
      if (!form) return;
      var box = form.querySelector('[data-wsopt]');
      if (!box || box.hidden) return;
      if (!missing(box).length) return;
      var btn = btnOf(box);
      if (!btn) return;
      var hit = (t === btn) || btn.contains(t);
      if (!hit && e.clientX) {
        var r = btn.getBoundingClientRect();
        hit = e.clientX >= r.left && e.clientX <= r.right &&
              e.clientY >= r.top  && e.clientY <= r.bottom;
      }
      if (hit) showMsgs(box);
    }, true);

    // ⓘ はモバイルでホバーできないのでタップで開閉する
    document.addEventListener('click', function (e) {
      var tip = e.target && e.target.closest ? e.target.closest('[data-wsopt-tip]') : null;
      var opened = document.querySelectorAll('[data-wsopt-tip].is-open');
      for (var i = 0; i < opened.length; i++) {
        if (opened[i] !== tip) opened[i].classList.remove('is-open');
      }
      if (tip) { tip.classList.toggle('is-open'); e.preventDefault(); }
    }, false);

    // テーマ/アプリが disabled を書き換えたら掛け直す
    if (window.MutationObserver) {
      var timer = null;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(syncAll, 120);
      }).observe(document.body, {
        childList: true, subtree: true,
        attributes: true, attributeFilter: ['disabled']
      });
    }

    document.addEventListener('variant:change', syncAll, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
